class AppDialog {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("appDialog", () => ({
                    init() {
                        setTimeout(() => {
                            if (
                                !window.useCookieStorage?.get("app_dialog") &&
                                !document.querySelector("#qc-cmp2-main")
                            ) {
                                document
                                    .querySelector(`[x-ref='dialogApp']`)
                                    ?.showModal();
                            }
                        }, 1000);
                    },
                    closeAppDialog() {
                        window.useCookieStorage?.set("app_dialog", true, {
                            maxAge: 3600 * 24 * 31,
                        });
                    },
                }));
            },
            { once: true },
        );
    }
}

new AppDialog();
